import { render, staticRenderFns } from "./CopyrightAssignmentTransferApplications.vue?vue&type=template&id=7cc1153c&scoped=true&"
import script from "./CopyrightAssignmentTransferApplications.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferApplications.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferApplications.vue?vue&type=style&index=0&id=7cc1153c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc1153c",
  null
  
)

export default component.exports